import React from "react";
import { ShieldCheck } from "lucide-react";

const POINTS = [
  "No account, no ads, no chat. Kids play with a first name and an avatar only.",
  "Dog Walker is completely free. Unlocking the other 3 businesses is a one-time $8.99 through Stripe — a grown-up handles checkout.",
  "The global leaderboard shows only a first name and avatar. Save codes and scores auto-delete after a long stretch of inactivity.",
];

const ParentsNote = () => (
  <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12" data-testid="landing-parents">
    <div className="bg-slate-900 text-white rounded-3xl p-6 sm:p-8 border-b-8 border-slate-700 grid md:grid-cols-12 gap-6 items-start">
      <div className="md:col-span-4">
        <div className="inline-flex items-center gap-2 text-xs font-black uppercase tracking-widest text-emerald-300 mb-2">
          <ShieldCheck className="w-4 h-4" /> For grown-ups
        </div>
        <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">Safe, simple, and kid-first</h2>
      </div>
      <ul className="md:col-span-8 space-y-3">
        {POINTS.map((p, i) => (
          <li key={i} className="flex gap-3 text-sm sm:text-base font-medium text-slate-200 leading-relaxed" data-testid={`landing-parent-point-${i + 1}`}>
            <span className="text-emerald-400 font-black">✓</span> {p}
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default ParentsNote;
